import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Link from './link.vue'

type colorType = 'blue' | 'yellow' | 'red' | 'green' | 'gray'
const colorTypes = ['blue', 'yellow', 'red', 'green', 'gray'] as const

export const linkColorMap = {
  blue: {
    link: '#005ce5',
    visited: '#722ed1',
    hover: '#277ff2',
    active: '#0046bf',
  },
  yellow: {
    link: '#faad14',
    visited: '#d4b106',
    hover: '#ffc53d',
    active: '#d48806',
  },
  red: {
    link: '#f5222d',
    visited: '#a8071a',
    hover: '#ff4d4f',
    active: '#cf1322',
  },
  green: {
    link: '#52c41a',
    visited: '#237804',
    hover: '#73d13d',
    active: '#389e0d',
  },
  gray: {
    link: '#bfbfbf',
    visited: '#595959',
    hover: '#d9d9d9',
    active: '#8c8c8c',
  },
}

// 定义组件props
export const linkProps = buildProps({
  value: {
    type: String,
    default: '',
  },
  href: {
    type: String,
    default: '',
  },
  prefixIcon: {
    type: String,
    default: '',
  },
  suffixIcon: {
    type: String,
    default: '',
  },
  // 图标与文字间距
  gap: {
    type: definePropType<string | number>([String, Number]),
    default: 4,
  },
  iconSize: {
    type: Number,
    default: 14,
  },
  target: {
    type: String,
    default: '_blank',
  },
  colorType: {
    type: definePropType<colorType>(String),
    default: 'blue',
    values: colorTypes,
  },

  // 自动划线
  underlineStatus: {
    type: String,
    default: 'none',
    values: ['none', 'hover', 'fixed'],
  },

  disabled: {
    type: Boolean,
    default: false,
  },
  // 是否开启轮换
  typeChange: {
    type: Boolean,
    default: false,
  },
  preview: {
    type: Boolean,
    default: false,
  },
  linkColor: {
    type: String,
    default: '',
  },
  // visitedColor: {
  //   type: String,
  //   default: '',
  // },
  hoverColor: {
    type: String,
    default: '',
  },
  activeColor: {
    type: String,
    default: '',
  },
} as const)

// props
export type LinkProps = ExtractPropTypes<typeof linkProps>

// instance
export type LinkInstance = InstanceType<typeof Link>
